import {
	authHeaders,
	useAuthTokenGetter,
} from "@memorang/ui/contexts/AuthTokenContext";
import { fetch as expoFetch } from "expo/fetch";
import { useCallback, useEffect, useState } from "react";
import { ENDPOINT_SESSION_ANALYSIS } from "../constants";

type Params = {
	sessionId: number;
	examName: string;
	tenantName: string;
	outputLanguage?: string;
	examId: string;
	appId: string;
};

export const useSessionAnalysis = ({
	sessionId,
	examName,
	tenantName,
	outputLanguage,
	examId,
	appId,
}: Params) => {
	const getAuthToken = useAuthTokenGetter();
	const [sessionAnalysis, setSessionAnalysis] = useState("");
	const [loading, setLoading] = useState(false);
	const [streaming, setStreaming] = useState(false);

	// biome-ignore lint/correctness/useExhaustiveDependencies: // TODO fix me later
	const fetchSessionAnalysis = useCallback(async () => {
		if (sessionId) {
			setLoading(true);
			const token = await getAuthToken();
			const response = await expoFetch(ENDPOINT_SESSION_ANALYSIS, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "text/event-stream",
					...authHeaders(token),
				},
				body: JSON.stringify({
					sessionId,
					examName,
					tenantName,
					outputLanguage,
					examId: `${examId}`,
					useSupabaseStore: true,
					appId,
				}),
			});
			const reader = await response.body?.getReader();
			let result = "";
			const encoder = new TextDecoder();
			let done = false;
			setLoading(false);
			setStreaming(true);
			while (!done && reader) {
				const { value, done: _done } = await reader.read();
				done = _done;
				if (value) {
					result += encoder.decode(value, { stream: !done });
				}
				setSessionAnalysis(result);
			}
			setStreaming(false);
		}
	}, [sessionId]);

	useEffect(() => {
		fetchSessionAnalysis();
	}, [fetchSessionAnalysis]);
	return {
		sessionAnalysis,
		loading,
		streaming,
	};
};
